var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"description-items"},_vm._l((_vm.displayDescriptionItems),function(item,i){return _c('li',{key:item,staticClass:"description-items__item",class:{'description-items__item_even': i % 2 === 0},domProps:{"innerHTML":_vm._s(item)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }